<template>
    <div class="alert" ref="timer" :class="{'alert_active': alert.open, 'alert--success': alert.status === 'success', 'alert--warning': alert.status === 'warning'}" >
        <span class="alert__text mr-12">{{ alert.text }}</span>

        <div v-if="!timerEnd && alert.timer" class="alert__timer">
            <icon-donut width="25px" height="25px" />

            <span class="alert__text">{{ this.alert.timer }}</span>
        </div>

        <div v-else class="alert__close" @click="closeAlert">
            <icon-base width="14" height="14" viewBox="0 0 14 14" iconColor="#fff"><icon-cancel /></icon-base>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

export default {
    data() {
        return {
            // Запоминаем сколько всего было секунд
            startSecond: null,
            timerEnd: true
        }
    },
    methods: {
        ...mapMutations('common', ['TOGGLE_ALERT', 'SET_ALERT_TIMER']),

        timer() {
            const el = this.$refs.timer
            // console.log('timer func');
            const timer = setInterval(() => {
                if (this.alert.timer <= 0) {
                    this.timerEnd = true
                    clearInterval(timer); // Таймер удаляется
                    this.closeAlert();
                } else {
                    const segment = el.querySelector('.donut-segment')
                    let newTimer = this.alert.timer - 1;
                    this.SET_ALERT_TIMER(newTimer); // Уменьшаем таймер
                    segment.style.strokeDashoffset=`${-100 + this.alert.timer / this.startSecond * 100}`
                }
            }, 1000)
        },

        closeAlert() {
            this.TOGGLE_ALERT({open: false})
        }
    },
    computed: {
        ...mapState('common', ['alert'])
    },
    watch: {
        'alert.open': function(val) {
            if (val) {
              if (this.alert.timer) {
                this.startSecond = this.alert.timer;
                this.timerEnd = false
                // this.timeSecond = alert.timer;
                this.timer()
                }
            }
        }
    }
}
</script>